/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_You_SuffixInputs */

const en_ui_you_suffix = /** @type {(inputs: Ui_You_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(you)`)
};

const de_ui_you_suffix = /** @type {(inputs: Ui_You_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(du)`)
};

/**
* | output |
* | --- |
* | "(you)" |
*
* @param {Ui_You_SuffixInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_you_suffix = /** @type {((inputs?: Ui_You_SuffixInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_You_SuffixInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ui_you_suffix(inputs)
	return en_ui_you_suffix(inputs)
});